import { useMemo } from "react"
import IntegrationStatusTag from "./IntegrationStatusTag"
import { useGetEmbedStatsOrgQuery } from "../../../../../redux/queries"
import { useAppSelector } from "../../../../hooks"
import { selectUserDetails } from "../../../../../redux/slices/auth"
import Badge from "../../../badge"

interface Props {
  integrationId: string
  className?: string
  statusClassName?: string
}

const IntegrationViewsStatusTag = ({
  integrationId,
  className = "",
  statusClassName
}: Props) => {
  const userDetails = useAppSelector(selectUserDetails)
  const orgId = userDetails?.org?.id

  const { data: embedStatsData = [] } = useGetEmbedStatsOrgQuery(
    { org_id: Number(orgId!), range: 36500 },
    { skip: !orgId }
  )

  const viewsData = useMemo(() => {
    return (
      embedStatsData.find(row => String(row.id) === integrationId)?.requests ||
      0
    )
  }, [embedStatsData, integrationId])

  const views = useMemo(() => {
    return typeof viewsData === "string" ? parseInt(viewsData, 10) : viewsData
  }, [viewsData])

  const numericViews = useMemo(() => {
    return (isNaN(views) ? 0 : views).toLocaleString()
  }, [views])

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <IntegrationStatusTag
        integrationId={integrationId}
        className={statusClassName}
      />
      <Badge.Info className="min-w-9 h-5 text-center py-0 leading-5 hidden">
        {numericViews}
      </Badge.Info>
    </div>
  )
}

export default IntegrationViewsStatusTag
